import React from "react";
import { Row, Col } from "react-bootstrap";
import "./CoverLetterPromo.css";

function CoverLetterPromo() {
  const points = [
    "Attractive and Recruiter friendly resume format",
    "Attractive and Recruiter friendly resume format",
    "Attractive and Recruiter friendly resume format"
  ];

  return (
    <div className="cover-letter-promo-section mb-5">
      <div className="promo-banner-card p-4 rounded-3">
        <Row className="align-items-center g-3">
          {/* Left Side Illustration Placeholder */}
          <Col md={4} className="text-center d-flex justify-content-center">
            <div className="promo-illustration-mock">
              {/* SVG vector representing the magnifying glass and document theme */}
              <svg viewBox="0 0 200 150" width="180" height="180">
                <rect x="70" y="20" width="50" height="70" rx="4" fill="#fff" stroke="#dee2e6" strokeWidth="2" />
                <rect x="80" y="35" width="30" height="4" fill="#ff007f" rx="2" />
                <circle cx="85" cy="50" r="4" fill="#333" />
                <rect x="94" y="48" width="16" height="4" fill="#dee2e6" />
                <path d="M40,90 Q50,40 70,80 T100,70" fill="none" stroke="#6f42c1" strokeWidth="3" />
                <circle cx="40" cy="90" r="8" fill="#6f42c1" />
              </svg>
            </div>
          </Col>

          {/* Right Side Content List */}
          <Col md={8}>
            <h4 className="fw-bold text-dark mb-3 dynamic-heading">
              Add cover letter for additional benefits
            </h4>
            <ul className="list-unstyled promo-benefits-list m-0">
              {points.map((text, idx) => (
                <li key={idx} className="d-flex align-items-start gap-2 mb-2 small text-secondary">
                  <span className="check-icon-circle">✓</span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default CoverLetterPromo;